module.exports = __webpack_public_path__ + "static/media/vehicle.9894342c.svg";